export const normalizeFieldValue = (value: string | undefined): string => {
  if (value) {
    return value.charAt(0) + value.slice(1).toLowerCase();
  } else {
    return '';
  }
};
